import { useContext } from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay/legacy';

// components
import { PdpSharedContactDealerButton } from '../PdpSharedButtons/PdpSharedContactDealerButton';
import { PdpSharedContactSupportButton } from '../PdpSharedButtons/PdpSharedContactSupportButton';
import { PdpSharedRequestHold } from '../PdpSharedButtons/PdpSharedRequestHold';
import {
    sellerIsHereToHelpMessage,
    lookingSomethingSimilar,
    startConversationMessage,
} from '../pdpMessages';
import { ServerVarsContext } from '../../global/ServerVarsContext/ServerVarsContext';
import { PdpSharedContactSellerButton } from '../PdpSharedContactSellerButton/PdpSharedContactSellerButton';

// styles
import styles from './PdpRespSidebarContact.scss';

// helpers
import get from 'lodash.get';

export const PdpRespSidebarContactComponent = props => {
    const { item, user, itemId, selectedSkuId, userId, viewer } = props;
    const { isContactSupportEnabled, isMessageCenterEnabled } = viewer;
    const pricingDisplayInfo = get(props, 'displayInfo.pricing') || null;
    const { isSoldPdpRedesign } = useContext(ServerVarsContext);

    if (!item || !pricingDisplayInfo) {
        return null;
    }

    let supportButton = null;
    if (isMessageCenterEnabled) {
        supportButton = isSoldPdpRedesign ? (
            <PdpSharedContactSellerButton
                fullWidth
                type="primary"
                size="medium"
                className={styles.contactSellerButton}
                launchOrigin="contact link in pdp - sidebar"
                viewer={viewer}
                user={user}
                item={item}
            >
                {startConversationMessage}
            </PdpSharedContactSellerButton>
        ) : (
            <PdpSharedContactDealerButton
                buttonType="secondary"
                user={user}
                item={item}
                selectedSkuId={selectedSkuId}
                viewer={viewer}
            />
        );
    } else if (isContactSupportEnabled) {
        supportButton = <PdpSharedContactSupportButton user={user} item={item} />;
    }

    return (
        supportButton && (
            <>
                {isSoldPdpRedesign ? (
                    <div className={styles.questionsSoldRedesign}>{lookingSomethingSimilar}</div>
                ) : (
                    <div className={styles.questions}>{sellerIsHereToHelpMessage}</div>
                )}

                <div className={styles.buttons}>
                    <div className={styles.requestPrice}>{supportButton}</div>

                    <PdpSharedRequestHold
                        item={item}
                        userId={userId}
                        itemId={itemId}
                        trackingLocation="pdp sidebar"
                    />
                </div>
            </>
        )
    );
};

PdpRespSidebarContactComponent.propTypes = {
    userId: PropTypes.string,
    itemId: PropTypes.string.isRequired,
    selectedSkuId: PropTypes.string,
    item: PropTypes.object,
    relay: PropTypes.object,
    small: PropTypes.bool,
    user: PropTypes.object,
    viewer: PropTypes.object.isRequired,
};

export const PdpRespSidebarContact = createFragmentContainer(PdpRespSidebarContactComponent, {
    viewer: graphql`
        fragment PdpRespSidebarContact_viewer on Viewer {
            ... @include(if: $fetchPdp) {
                ...PdpSharedContactSellerButton_viewer
                ...PdpSharedContactDealerButton_viewer
                isContactSupportEnabled: isEnabledByLocale(featureName: "CONTACT_1STDIBS")
                isMessageCenterEnabled: isEnabledByLocale(featureName: "MESSAGE_CENTER")
            }
        }
    `,
    displayInfo: graphql`
        fragment PdpRespSidebarContact_displayInfo on ItemDisplayInfo {
            pricing {
                showSold
                showUnavailable
            }
        }
    `,
    item: graphql`
        fragment PdpRespSidebarContact_item on Item {
            isCustomizable
            ...PdpSharedRequestHold_item
            ...PdpSharedContactDealerButton_item
            ...PdpSharedMakeOfferButton_item
            ...PdpSharedContactSupportButton_item
            ...PdpSharedContactSellerButton_item
        }
    `,
    user: graphql`
        fragment PdpRespSidebarContact_user on User {
            isVerifiedTrade
            ...PdpSharedContactDealerButton_user
            ...PdpSharedMakeOfferButton_user
            ...PdpSharedContactSupportButton_user
            ...PdpSharedContactSellerButton_user
        }
    `,
});
